import { render, staticRenderFns } from "./MeunTextItem.vue?vue&type=template&id=6cab657a&scoped=true&"
import script from "./MeunTextItem.vue?vue&type=script&lang=js&"
export * from "./MeunTextItem.vue?vue&type=script&lang=js&"
import style0 from "./MeunTextItem.vue?vue&type=style&index=0&id=6cab657a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cab657a",
  null
  
)

export default component.exports